var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-with-label"},[_c('textarea',_vm._g(_vm._b({class:[
      'input-textarea',
      {
        light: _vm.light,
        resize: _vm.resize,
        long: _vm.long,
        short: _vm.short,
        instruction: _vm.instruction,
      } ],attrs:{"type":"textarea","autocomplete":"off"},on:{"input":function($event){return _vm.$emit('update', $event.target.value)}}},'textarea',
      _vm.$attrs
      // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
    ,false),_vm.$listeners)),(_vm.error)?_c('span',{staticClass:"input-error-text"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }